








































import Vue from 'vue';
import moment from 'moment';
import Sex from './settings/Sex.vue';
import SubscribeTime from './settings/SubscribeTime.vue';
import Area from './settings/Area.vue';
import SubscribeScene from './settings/SubscribeScene.vue';
import Topic from './settings/Topic.vue';
import Interact from './settings/Interact.vue';
import Trace from './settings/Trace.vue';
import Score from './settings/Score.vue';
import Member from './settings/Member.vue';
import Group from './settings/Group.vue';
import Remark from './settings/Remark.vue';
import Custom from './settings/Custom.vue';
import SubscribeStatus from './settings/SubscribeStatus.vue';
import customerVuex from '../../vuex/common';
import format from './makeCustomerQuery';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    Sex,
    Topic,
    SubscribeTime,
    Area,
    SubscribeScene,
    SubscribeStatus,
    Interact,
    Trace,
    Score,
    Member,
    Group,
    Remark,
    Custom,
  },
  data() {
    return {
      bodyHeight: 0,
    };
  },
  computed: {
    bodyStyles(): any {
      return {
        height: `${this.bodyHeight}px`,
      };
    },
  },
  methods: {
    resetFilter() {
      this.$store.commit('RESET_CUSTOMER_QUERY');
      this.$emit('reset');
    },
    confirmFilter() {
      const query = format.mkFilterQueries(this.customerFilter);
      const oriQquery = this.customerState.customerQuery;
      query.page = oriQquery.page;
      query.pageSize = oriQquery.pageSize;
      query.sort = oriQquery.sort;
      this.$store.commit('SET_CUSTOMER_QUERY', JSON.parse(JSON.stringify(query)));
      this.$store.commit('CUSTOMER_TABLE_REFRESH');
      this.$emit('hasFilter');
    },
    setBodyHeight() {
      this.bodyHeight = window.document.body.offsetHeight - 347;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.setBodyHeight();
    });
    const fb: any = window.document.getElementById('filter-body');
    fb.onmousewheel = (event: any) => {
      fb.scrollTop += event.deltaY;
    };
    this.$nextTick(() => {
      this.setBodyHeight();
    });
  },
});
